"use client"
import { Box } from "@quintoandar-tokko/jopijs";
import Skeletons from "@/components/fichaInfo/skelenton/Skeleton";
import DatePickerSkeleton from "../datepicker/DatepickerSkeleton";
import style from './calendarSkeleton.module.scss';

export default function CalendarSkeleton() {
  return (
    <Box className={style.skeletonContainer}>
      <Box className={style.skeletonLeftSide}>
        <Skeletons width={200} height={28} borderRadius={8} />
        <Skeletons width={330} height={76} borderRadius={8} />
        <Skeletons width={80} height={20} borderRadius={8} />
        <Skeletons width={80} height={20} borderRadius={8} />
        <Skeletons width={150} height={46} borderRadius={8} />
      </Box>

      <Box className={style.skeletonRightSide}>
        <Skeletons width={300} height={24} borderRadius={8} />
        <Skeletons width={220} height={20} borderRadius={8} />
        <Box className={style.label}>
          <Skeletons width={130} height={16} borderRadius={8} />
        </Box>
        <Box className={style.lowerRightSection}>
          <Box className={style.skeletonDatepickerWrapper}>
            <DatePickerSkeleton />
          </Box>
          <Box className={style.skeletonButtons}>
            <Skeletons width={148} height={40} borderRadius={8} />
            <Skeletons width={148} height={40} borderRadius={8} />
            <Skeletons width={148} height={40} borderRadius={8} />
            <Skeletons width={148} height={40} borderRadius={8} />
            <Skeletons width={148} height={40} borderRadius={8} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
